export default __webpack_public_path__ + "static/media/icon-plan-dental.515faa4e.svg";